import { Button, LogoutIcon } from 'internalLibrary';
import { ButtonProps } from 'internalLibrary/components/atoms/Button/Button';
import { PropsWithChildren } from 'react';
import classes from 'classnames';
import styles from './LogoutButton.module.scss';

export default function LogoutButton({
  className,
  ...props
}: PropsWithChildren<ButtonProps>) {
  return (
    <Button
      rightIcon={<LogoutIcon />}
      {...props}
      className={classes(
        className,
        styles['logout-button'],
        styles['logout-icon'],
      )}
    />
  );
}
